import React, { useEffect, useState, useCallback } from 'react';
import DataTable from './DataTable';
import axiosInstance from '../utils/axiosInstance';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const POLLING_INTERVAL = 10000; // 10 saniyede bir otomatik yenileme

const PendingRequests = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    
    // Modal State'leri
    const [rejectId, setRejectId] = useState(null); 
    const [rejectReason, setRejectReason] = useState("");

    // Veri Çekme Fonksiyonu
    const fetchPendingRequests = useCallback(async () => {
    try {
      const response = await axiosInstance.get('/request');
      
      // 1. Önce bekleyenleri filtrele
      const pendingData = response.data.filter(req => req.status === "pending");
      
      // 2. Tarihe göre yeniden eskiye (descending) sırala
      const sortedData = pendingData.sort((a, b) => {
        return new Date(b.createdAt) - new Date(a.createdAt);
      });

      setData(sortedData); // Sıralanmış veriyi state'e aktar
      setLoading(false);
    } catch (error) {
      console.error("Veri çekme hatası:", error);
      setLoading(false);
    }
  }, []);

    // Otomatik Polling & İlk Çekim
    useEffect(() => {
        fetchPendingRequests();
        const interval = setInterval(fetchPendingRequests, POLLING_INTERVAL);
        return () => clearInterval(interval);
    }, [fetchPendingRequests]);

    // ✅ Talebi Onaylama (Approved)
    const handleApprove = async (username) => {
        if (window.confirm(`${username} isimli kullanıcının talebini onaylıyor musunuz?`)) {
            const loadToast = toast.loading("İşlem yapılıyor...");
            try {
                const response = await axiosInstance.post(`/request/update`, { 
                    username, 
                    status: 'approved', 
                    rejectReason: 'Manuel onaylama' 
                });

                if (response.status === 200) {
                    toast.update(loadToast, { render: "Talep Başarıyla Onaylandı!", type: "success", isLoading: false, autoClose: 3000 });
                    fetchPendingRequests();
                }
            } catch (error) {
                toast.update(loadToast, { render: "❌ Hata oluştu!", type: "error", isLoading: false, autoClose: 3000 });
            }
        }
    };

    // ✅ Red Modalını Açma
    const openRejectModal = (username) => {
        setRejectId(username);
    };

    // ✅ Red Modalını Kapatma
    const closeRejectModal = () => {
        setRejectId(null);
        setRejectReason("");
    };

    // ✅ Talebi Reddetme (Rejected)
    const handleReject = async () => {
        if (!rejectReason.trim()) {
            toast.warn("⚠️ Lütfen bir red nedeni girin!");
            return;
        }

        const loadToast = toast.loading("Red işlemi yapılıyor...");
        try {
            await axiosInstance.post(`/request/update`, { 
                username: rejectId, 
                status: 'rejected', 
                rejectReason 
            });

            toast.update(loadToast, { render: "Talep reddedildi.", type: "error", isLoading: false, autoClose: 3000 });
            fetchPendingRequests();
            closeRejectModal();
        } catch (error) {
            toast.update(loadToast, { render: "⚠️ İşlem başarısız!", type: "warning", isLoading: false, autoClose: 3000 });
        }
    };

    if (loading && data.length === 0) {
        return <div className="data-page-container"><p>Yükleniyor...</p></div>;
    }

    return (
        <div className="page-content-wrapper">
            {/* Bildirim Konteyneri */}
            <ToastContainer theme="dark" position="top-right" />

            <DataTable 
                title="Bekleyen Talepler" 
                data={data} 
                isPendingPage={true} 
                fetchData={fetchPendingRequests} 
                handleApprove={handleApprove}
                openRejectModal={openRejectModal}
            />

            {/* MODAL: Reddetme Ekranı */}
            {rejectId && (
                <div className="modal-overlay" onClick={closeRejectModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Talebi Reddet</h3>
                            <p><strong>{rejectId}</strong> kullanıcısı için bir açıklama girin.</p>
                        </div>
                        
                        <textarea 
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            placeholder="Red sebebini buraya yazın..."
                            autoFocus
                        />

                        <div className="modal-actions">
                            <button className="btn-modal btn-cancel" onClick={closeRejectModal}>
                                Vazgeç
                            </button>
                            <button className="btn-modal btn-confirm-reject" onClick={handleReject}>
                                Talebi Reddet
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PendingRequests;